import { FC } from "react";
interface BotTemplateCardType {
    title: string;
    description?: string;
    count?: string;
    image: string;
    tag: { name: string }[];
    id: string;
    name: string;
    href?: any;
    category: string;
    buttonText?: string;
}
const BotTemplateCard: FC<BotTemplateCardType> = (props) => {
    const { title, description, count, tag, image, name, id, href, category, buttonText = "Try" } = props;
    const cardname = name.trim().toLowerCase().split(" ").join("-");
    const categoryname = category?.trim().toLowerCase()?.split(" ")?.join("-");
    return (
        <a href={`/whatsapp-chatbot-templates/${categoryname}/${cardname}/${id}`} className="hover:no-underline">
            <div className="bot-card-component mx-auto">
                <div style={{ minWidth: "350px", height: "200px" }} className="flex">
                    <img width="100%" height={200} key={name} src={image} alt={title} className="flex-shrink" />
                </div>
                <div className="px-5 my-5">
                    <p className="title truncate-two-line" style={{ minHeight: "50px" }}>
                        {title}
                    </p>
                    <div className="flex flex-row gap-1 items-center">
                        <div className="flex flex-row gap-1">
                            {tag.map((eachtag: { name: string }, i: number) => {
                                if (i > 1) {
                                    return null;
                                }
                                return (
                                    <p className="tag  py-0.5 text-center px-1" key={i}>
                                        {eachtag.name}
                                    </p>
                                );
                            })}
                        </div>
                        <p style={{ fontSize: "11px", color: "#162C6E" }}>{tag.length - 1 > 1 ? `+${tag.length - 2}` : ""}</p>
                    </div>
                    {description && <p className="description truncate-three-line mt-3 mb-5">{description}</p>}

                    <div className="flex gap-2 w-fit my-3">
                        {href ? (
                            <a className="try flex justify-center items-center" href={href}>
                                <span>{buttonText}</span>
                            </a>
                        ) : (
                            <button
                                className="w-fit px-2 py-1 rounded-md font-medium text-sm hover:bg-gray-50 hover:shadow-md"
                                style={{ border: "1px solid #0083ff", color: "#0083ff" }}
                            >
                                {buttonText}
                            </button>
                        )}
                        {count && (
                            <div className="flex items-center mr-0.5">
                                <img src="https://assets.gallabox.com/gb-home/bot-templates/icons/eye-view-icon.png" alt="" className="w-3 ml-2" />
                                <p className="view-count ml-1">{count <= "20" ? "20" : count}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </a>
    );
};
export default BotTemplateCard;
